// Tab Dados bancários (leitura nesta onda) — é a conta de repasse do lojista.
import { useTranslation } from "react-i18next"

import type { AdminMerchant } from "@/types/admin-merchant"

import { ReadOnlyField } from "./read-only-field"

const panelPrefix = "pages.adminMerchants"

type MerchantBankTabProps = {
  merchant: AdminMerchant
}

export const MerchantBankTab = ({
  merchant,
}: MerchantBankTabProps) => {
  const { t } = useTranslation()
  const bank = merchant.bank

  if (!bank) {
    return (
      <div
        data-testid="merchant-bank-empty"
        className="flex flex-col items-center gap-2 rounded-xl border border-dashed px-6 py-14 text-center"
      >
        <p className="text-sm text-muted-foreground">
          {t(`${panelPrefix}.bank.empty`)}
        </p>
      </div>
    )
  }

  const institution = bank.bank?.number
    ? `${bank.bank.number} — ${bank.bank.name ?? ""}`.trim()
    : bank.bank?.name

  return (
    <section className="rounded-xl border bg-card p-4 shadow-sm">
      <div className="grid grid-cols-1 gap-4 @2xl:grid-cols-2 @5xl:grid-cols-3">
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.bank`)}
          value={institution}
          className="@5xl:col-span-2"
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.dictKey`)}
          value={bank.dictKey}
          mono
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.agency`)}
          value={bank.agency}
          mono
        />
        <ReadOnlyField
          label={t(
            `${panelPrefix}.fields.agencyCheckNumber`
          )}
          value={bank.agencyCheckNumber}
          mono
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.accountNumber`)}
          value={bank.accountNumber}
          mono
        />
        <ReadOnlyField
          label={t(
            `${panelPrefix}.fields.accountCheckNumber`
          )}
          value={bank.accountCheckNumber}
          mono
        />
      </div>
    </section>
  )
}
